// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyV1CardFinderDefaultResponseData {
    static getAttributeTypeMap() {
        return PharmacyV1CardFinderDefaultResponseData.attributeTypeMap;
    }
}
PharmacyV1CardFinderDefaultResponseData.discriminator = undefined;
PharmacyV1CardFinderDefaultResponseData.additionalProperties = false;
PharmacyV1CardFinderDefaultResponseData.attributeTypeMap = [
    {
        "name": "transactionCorrelationId",
        "baseName": "transactionCorrelationId",
        "type": "number"
    },
    {
        "name": "ndc",
        "baseName": "ndc",
        "type": "string"
    },
    {
        "name": "prescriberNpi",
        "baseName": "prescriberNpi",
        "type": "string"
    },
    {
        "name": "plans",
        "baseName": "plans",
        "type": "Array<Plan>"
    },
];
//# sourceMappingURL=pharmacyV1CardFinderDefaultResponseData.js.map